import angular from 'angular';
import { LoadingComponent } from './loading.component.js';

const loading = angular.module('loading', []);

loading.component('loading', LoadingComponent);

export { loading };



// WEBPACK FOOTER //
// ./app/components/common/loading/loading.js